import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useLang } from '../../../util/lang';
import Modal from '../../Modal/modal';
import instance, { safeGet } from '../../../axios-default';
import RetrackReportPreview from './RetrackReport/RetrackReportPreview';
import { ApiServerUrl } from '../../../../src/config.json';
import moment from 'moment';
import LoadingSpinner from '../../Loader/LoadingSpinner';

const ViewRetrackReportModal = ({
    viewRetrackReportModalState,
    loadingState,
    caseRetrackReportId,
    handleClose,
    caseId,
}) => {
    const get = useLang();
    const [data, setData] = useState(null);
    const [isLoading, setIsloading] = useState(true);
    const handleCloseFunc = useCallback(() => {
        handleClose();
    }, []);

    const fetchRetrackReport = useCallback(async () => {
        if (caseRetrackReportId && caseId) {
            setIsloading(true);
            const data = await safeGet(`/retrack/getRetrackReport/${caseId}/${caseRetrackReportId}`);
            let result = data.result;
            Object.keys(result).forEach((key) => {
                if (typeof result[key] === 'string' && result[key].includes('/file/')) {
                    result[key] = ApiServerUrl.replace(/\/$/, '') + result[key];
                } else if (key === 'created_date') {
                    result[key] = moment(result[key]).format('YYYY-MM-DD');
                } else {
                    result[key] = result[key];
                }
            });
            setData(result);
            setIsloading(false);
        }
    }, [caseRetrackReportId, caseId]);

    useEffect(() => {
        if (viewRetrackReportModalState && !loadingState && caseRetrackReportId) {
            fetchRetrackReport();
        }
    }, [viewRetrackReportModalState, caseRetrackReportId]);

    return (
        <Modal
            modal="viewRetrackReportModal"
            title={'Retrack Report'}
            open={viewRetrackReportModalState && !loadingState}
            handleClose={handleCloseFunc}
        >
            <>{isLoading ? <LoadingSpinner /> : <RetrackReportPreview defaultValues={data} />}</>
        </Modal>
    );
};

export default React.memo(ViewRetrackReportModal);
